import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "../material-module/material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { DodoRaisedButtonComponent } from "./buttons/dodo-raised-button/dodo-raised-button.component";
import { DodoIconRaisedButtonComponent } from "./buttons/dodo-icon-raised-button/dodo-icon-raised-button.component";
import { TealiumModule } from "../../tealium/tealium.module";
// import {
// 	SwiperModule,
// 	SWIPER_CONFIG,
// 	SwiperConfigInterface,
// } from "@sonrisa-dev/ngx-swiper-wrapper-sonfork";
import { DodoTooltipComponent } from "./tooltip/tooltip.component";
import { NbspIfEmptyPipe } from "./nbsp-if-empty.pipe";

const components = [
	DodoRaisedButtonComponent,
	DodoIconRaisedButtonComponent,
	DodoTooltipComponent,
];

// const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
// 	observer: true,
// 	direction: "horizontal",
// 	threshold: 50,
// 	slidesPerView: 2,
// 	keyboard: true,
// 	mousewheel: true,
// 	scrollbar: false,
// 	navigation: true,
// 	pagination: true,
// 	spaceBetween: 5,
// };

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		// SwiperModule,
		ReactiveFormsModule,
		MaterialModule,
		TealiumModule,
	],
	declarations: [...components, NbspIfEmptyPipe],
	exports: [...components],
	providers: [
		// {
		// 	provide: SWIPER_CONFIG,
		// 	useValue: DEFAULT_SWIPER_CONFIG,
		// },
	],
})
export class DodoMatComponentsCommonModule {}
